import { render, staticRenderFns } from "./lkuTrading.vue?vue&type=template&id=2a3bdc72"
import script from "./lkuTrading.vue?vue&type=script&lang=js"
export * from "./lkuTrading.vue?vue&type=script&lang=js"
import style0 from "./lkuTrading.vue?vue&type=style&index=0&id=2a3bdc72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports